import { createSlice } from '@reduxjs/toolkit';
import { DateTypes } from 'types/client';

import { NotificationState } from 'types/notification';
import { INITIAL_LIST_PARAMS } from 'config';

const initialState: NotificationState = {
  isLoading: false,
  notifications: {},
  notificationsListParams: INITIAL_LIST_PARAMS,
  pushTokens: [],
  filtersListParams: INITIAL_LIST_PARAMS,
  filtersErrors: {
    [DateTypes.CREATED_AT_START]: '',
    [DateTypes.CREATED_AT_END]: '',
  },
  massClientList: {},
  massClientListParams: INITIAL_LIST_PARAMS,
  singleClientList: {},
  singleClientListParams: INITIAL_LIST_PARAMS,
  massFiltersListParams: INITIAL_LIST_PARAMS,
  massFiltersErrors: {
    [DateTypes.CREATED_AT_START]: '',
    [DateTypes.CREATED_AT_END]: '',
    [DateTypes.PAID_AT_START]: '',
    [DateTypes.PAID_AT_END]: '',
    product_ids: '',
  },
  singleFiltersListParams: INITIAL_LIST_PARAMS,
  singleFiltersErrors: {
    [DateTypes.CREATED_AT_START]: '',
    [DateTypes.CREATED_AT_END]: '',
    [DateTypes.PAID_AT_START]: '',
    [DateTypes.PAID_AT_END]: '',
    product_ids: '',
  },
};

const slice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetError(state) {
      state.error = undefined;
    },

    getNotificationList(state, action) {
      state.isLoading = false;
      state.notifications = action.payload;
    },

    setNotificationListParams(state, action) {
      state.notificationsListParams = action.payload;
    },

    setFiltersListParams(state, action) {
      state.filtersListParams = action.payload;
    },

    setFiltersErrors(state, action) {
      state.filtersErrors = action.payload;
    },

    getMassNotificationClientListSuccess(state, action) {
      state.isLoading = false;
      state.massClientList = action.payload;
    },

    setMassNotificationClientListParams(state, action) {
      state.massClientListParams = action.payload;
    },

    getSingleNotificationClientListSuccess(state, action) {
      state.isLoading = false;
      state.singleClientList = action.payload;
    },

    setSingleNotificationClientListParams(state, action) {
      state.singleClientListParams = action.payload;
    },

    setMassFiltersListParams(state, action) {
      state.massFiltersListParams = action.payload;
    },

    setMassFiltersErrors(state, action) {
      state.massFiltersErrors = action.payload;
    },

    setSingleFiltersListParams(state, action) {
      state.singleFiltersListParams = action.payload;
    },

    setSingleFiltersErrors(state, action) {
      state.singleFiltersErrors = action.payload;
    },

    setPushTokens(state, action) {
      state.pushTokens = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  hasError,
  resetError,
  getNotificationList,
  setNotificationListParams,
  setFiltersListParams,
  setFiltersErrors,
  getMassNotificationClientListSuccess,
  setMassNotificationClientListParams,
  getSingleNotificationClientListSuccess,
  setSingleNotificationClientListParams,
  setMassFiltersListParams,
  setMassFiltersErrors,
  setSingleFiltersListParams,
  setSingleFiltersErrors,
  setPushTokens,
} = slice.actions;
